var map = {
	"./bg.json": "ac86",
	"./cs.json": "8f25",
	"./de.json": "8614",
	"./en.json": "6eb8",
	"./fr.json": "fcbc",
	"./hu.json": "7cbe",
	"./pl.json": "26dd",
	"./ro.json": "76be",
	"./ru.json": "a93b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c78";